module.exports = __webpack_public_path__ + "static/Tritech_2-b52500d54a9c13d2513f0e9878f5b9aa.webp";